<template>
  <v-row align="start" class="ma-0 pa-0 white">
    <v-row class="ma-0 pa-0">
      <v-col cols="12">
        <v-btn color="primary" to="/">Voltar</v-btn>
        <span class="ml-5 vetalfa-card-title"> Gestão de Clientes (CRM) </span>
      </v-col>
      <v-col cols="12">
        <p>Digite o ID do usuário para buscá-lo:</p>
        <v-row class="ma-0 pa-0">
          <v-text-field
            style="max-width: 300px"
            light
            dense
            class="mr-5"
            v-model="userAppUid"
            placeholder="Digite o ID"
            color="primary"
            outlined
          ></v-text-field>
          <v-btn
            :disabled="!userAppUid"
            color="primary"
            @click="getCustomersAsync()"
            >Buscar</v-btn
          >
        </v-row>
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12">
        <v-data-table
          hide-default-footer
          v-model="selected"
          :headers="headers"
          :items="customers"
          :single-select="true"
          item-key="uid"
          show-select
          class="elevation-1"
          color="primary"
        >
          <template v-slot:top>
            <v-row class="ma-0 pa-2">
              <v-spacer></v-spacer>
              <v-btn
                :disabled="
                  !selected ||
                  !selected.length ||
                  !customers ||
                  !customers.length
                "
                color="primary"
                @click="selectUserAsync"
              >
                Selecionar
              </v-btn>
            </v-row>
          </template>
          <template v-slot:no-data>
            <div>Sem resultados - Busque pelos usuários</div>
          </template>
          <template v-slot:[`item.uid`]="{ item }">
            {{ "VA-" + item.uid.slice(0, 8) }}
          </template>
        </v-data-table>
      </v-col>
      <v-dialog
        v-if="customer"
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon color="white" @click="dialog = false">
              <v-icon>{{ mdiClose }}</v-icon>
            </v-btn>
            <v-toolbar-title>Gestão do Cliente</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="saveCustomerSettingsAsync">
                Salvar
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-row class="ma-0 pa-0 mt-5">
            <v-col cols="12">
              <p>Dados do cadastro</p>
            </v-col>
            <v-col cols="4">
              <v-text-field
                dense
                light
                label="Nome"
                outlined
                v-model="customer.displayName"
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                dense
                light
                label="Email"
                outlined
                v-model="customer.email"
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                dense
                light
                label="Termos de Uso"
                outlined
                disabled
                v-model="customer.termsVersion"
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                dense
                light
                label="Data do cadastro"
                outlined
                :value="
                  new Date(customer.creationTime).toLocaleDateString('pt-BR')
                "
                disabled
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                dense
                light
                label="Data do último login"
                outlined
                :value="
                  new Date(customer.lastSignInTime).toLocaleDateString('pt-BR')
                "
                disabled
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                dense
                light
                label="Provedor de Login"
                outlined
                disabled
                v-model="customer.providerId"
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                dense
                light
                label="Status Assinatura"
                outlined
                disabled
                :value="purchaseStatus"
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                dense
                light
                label="Data início assinatura"
                outlined
                disabled
                :value="customer.android_purchaseStart"
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                dense
                light
                label="Data de cancelamento da assinatura"
                outlined
                disabled
                :value="customer.android_purchaseExpiry"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row class="ma-0 pa-0 mt-5">
            <v-col cols="12">
              <p>Dados do editáveis</p>
            </v-col>
            <v-col cols="4">
              <v-text-field
                dense
                light
                label="Telefone"
                outlined
                v-model="customer.phone"
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-select
                :items="['Pendente', 'Indeferido', 'Concluído']"
                label="Status da solicitação"
                hide-details
                filled
                class="mx-2 mb-5"
                dense
                outlined
                v-model="customer.status"
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-select
                :items="tags"
                label="Etiquetas"
                hide-details
                multiple
                filled
                class="mx-2 mb-5"
                chips
                dense
                outlined
                v-model="customer.tags"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-textarea
                auto-grow
                label="Notas de atendimento"
                rows="1"
                type="text"
                class="ma-0 pa-0"
                light
                counter="1000"
                dense
                color="primary"
                :value="customer.notes"
                v-model="customer.notes"
                :rules="[rules.length(1000)]"
                outlined
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </v-row>
  </v-row>
</template>

<script>
import { mdiClose } from "@mdi/js";
import { mapActions } from "vuex";
export default {
  name: "CustomersManagement",
  methods: {
    ...mapActions("management", [
      "getCustomers",
      "getCustomerWithUid",
      "saveCustomerSettings",
      "loginManagement",
    ]),
    async getCustomersAsync() {
      this.customers = await this.getCustomers(this.userAppUid);
      this.customer = null;
    },
    async selectUserAsync() {
      this.customer = await this.getCustomerWithUid(this.selected[0].uid);
      this.customer = { ...this.selected[0], ...this.customer };
      console.log(this.customer);
      this.customer.android_purchaseExpiry = !!this.customer
        .android_purchaseExpiry
        ? new Date(
            this.customer.android_purchaseExpiry._seconds * 1000
          ).toLocaleString("pt-BR")
        : null;
      this.customer.android_purchaseStart = !!this.customer
        .android_purchaseStart
        ? new Date(
            this.customer.android_purchaseStart._seconds * 1000
          ).toLocaleString("pt-BR")
        : null;
      this.dialog = true;
    },
    async saveCustomerSettingsAsync() {
      this.dialog = false;
      await this.saveCustomerSettings({
        uid: this.customer.uid,
        phone: this.customer.phone,
        tags: this.customer.tags,
        status: this.customer.status,
        notes: this.customer.notes,
        email: this.customer.email,
        displayName: this.customer.displayName,
      });
      this.customers = [];
    },
  },
  computed: {
    isDevelopment() {
      return process.env.NODE_ENV == "development";
    },
    purchaseStatus() {
      if (!this.customer || !this.customer.premiumStatus) {
        return "Não é assinante.";
      }
      return "Assinatura ativa.";
    },
  },
  data() {
    return {
      mdiClose,
      userAppUid: null,
      selected: null,
      customers: [],
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: true,
          value: "uid",
        },
        { text: "Nome", value: "displayName" },
        { text: "Email", value: "email" },
        { text: "Provedor de Login", value: "providerId" },
      ],
      customer: null,
      dialog: false,
      rules: {
        email: (v) => !!(v || "").match(/@/) || "Please enter a valid email",
        length: (len) => (v) =>
          (v || "").length <= len || `Invalid character length, max ${len}`,
        required: (v) => !!v || "This field is required",
      },
      tags: [
        "Sugestão de inclusão de itens na parte premium",
        "Sugestão de inclusão de itens na parte gratuita.",
        "Uso incorreto do aplicativo.",
        "Dúvidas diversas.",
        "Interesse no Alfa Plus.",
        "Sugestão de edições do conteúdo.",
        "BUG no aplicativo.",
        "Sugestão de novas funcionalidades/melhorias no APP.",
      ],
    };
  },
  created() {
    if (!this.isDevelopment) {
      this.loginManagement();
      window.onbeforeunload = function () {
        return "Are you sure";
      };
    }
  },
};
</script>
